require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./cljs.spec.alpha.js");

require("./expound.util.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("expound.paths.js");
goog.provide('expound.paths');
cljs.spec.alpha.def_impl(new cljs.core.Keyword("expound", "path", "expound/path", -1026376555), cljs.core.list(new cljs.core.Symbol("cljs.spec.alpha", "nilable", "cljs.spec.alpha/nilable", 1628308748, null), new cljs.core.Symbol("cljs.core", "sequential?", "cljs.core/sequential?", 1777854658, null)), cljs.spec.alpha.nilable_impl(new cljs.core.Symbol("cljs.core", "sequential?", "cljs.core/sequential?", 1777854658, null), cljs.core.sequential_QMARK_, null));
/**
* @constructor
 * @implements {cljs.core.IRecord}
 * @implements {cljs.core.IKVReduce}
 * @implements {cljs.core.IEquiv}
 * @implements {cljs.core.IHash}
 * @implements {cljs.core.ICollection}
 * @implements {cljs.core.ICounted}
 * @implements {cljs.core.ISeqable}
 * @implements {cljs.core.IMeta}
 * @implements {cljs.core.ICloneable}
 * @implements {cljs.core.IPrintWithWriter}
 * @implements {cljs.core.IIterable}
 * @implements {cljs.core.IWithMeta}
 * @implements {cljs.core.IAssociative}
 * @implements {cljs.core.IMap}
 * @implements {cljs.core.ILookup}
*/

expound.paths.KeyPathSegment = function (key, __meta, __extmap, __hash) {
  this.key = key;
  this.__meta = __meta;
  this.__extmap = __extmap;
  this.__hash = __hash;
  this.cljs$lang$protocol_mask$partition0$ = 2230716170;
  this.cljs$lang$protocol_mask$partition1$ = 139264;
};

expound.paths.KeyPathSegment.prototype.cljs$core$ILookup$_lookup$arity$2 = function (this__4380__auto__, k__4381__auto__) {
  var self__ = this;
  var this__4380__auto____$1 = this;
  return this__4380__auto____$1.cljs$core$ILookup$_lookup$arity$3(null, k__4381__auto__, null);
};

expound.paths.KeyPathSegment.prototype.cljs$core$ILookup$_lookup$arity$3 = function (this__4382__auto__, k27754, else__4383__auto__) {
  var self__ = this;
  var this__4382__auto____$1 = this;
  var G__27758 = k27754;
  var G__27758__$1 = G__27758 instanceof cljs.core.Keyword ? G__27758.fqn : null;

  switch (G__27758__$1) {
    case "key":
      return self__.key;
      break;

    default:
      return cljs.core.get.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k27754, else__4383__auto__);
  }
};

expound.paths.KeyPathSegment.prototype.cljs$core$IKVReduce$_kv_reduce$arity$3 = function (this__4399__auto__, f__4400__auto__, init__4401__auto__) {
  var self__ = this;
  var this__4399__auto____$1 = this;
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ret__4402__auto__, p__27759) {
    var vec__27760 = p__27759;
    var k__4403__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27760, 0, null);
    var v__4404__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27760, 1, null);
    return f__4400__auto__.cljs$core$IFn$_invoke$arity$3 ? f__4400__auto__.cljs$core$IFn$_invoke$arity$3(ret__4402__auto__, k__4403__auto__, v__4404__auto__) : f__4400__auto__.call(null, ret__4402__auto__, k__4403__auto__, v__4404__auto__);
  }, init__4401__auto__, this__4399__auto____$1);
};

expound.paths.KeyPathSegment.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (this__4394__auto__, writer__4395__auto__, opts__4396__auto__) {
  var self__ = this;
  var this__4394__auto____$1 = this;

  var pr_pair__4397__auto__ = function pr_pair__4397__auto__(keyval__4398__auto__) {
    return cljs.core.pr_sequential_writer(writer__4395__auto__, cljs.core.pr_writer, "", " ", "", opts__4396__auto__, keyval__4398__auto__);
  };

  return cljs.core.pr_sequential_writer(writer__4395__auto__, pr_pair__4397__auto__, "#expound.paths.KeyPathSegment{", ", ", "}", opts__4396__auto__, cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "key", "key", -1516042587), self__.key], null)], null), self__.__extmap));
};

expound.paths.KeyPathSegment.prototype.cljs$core$IIterable$_iterator$arity$1 = function (G__27753) {
  var self__ = this;
  var G__27753__$1 = this;
  return new cljs.core.RecordIter(0, G__27753__$1, 1, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "key", "key", -1516042587)], null), cljs.core.truth_(self__.__extmap) ? cljs.core._iterator(self__.__extmap) : cljs.core.nil_iter());
};

expound.paths.KeyPathSegment.prototype.cljs$core$IMeta$_meta$arity$1 = function (this__4378__auto__) {
  var self__ = this;
  var this__4378__auto____$1 = this;
  return self__.__meta;
};

expound.paths.KeyPathSegment.prototype.cljs$core$ICloneable$_clone$arity$1 = function (this__4375__auto__) {
  var self__ = this;
  var this__4375__auto____$1 = this;
  return new expound.paths.KeyPathSegment(self__.key, self__.__meta, self__.__extmap, self__.__hash);
};

expound.paths.KeyPathSegment.prototype.cljs$core$ICounted$_count$arity$1 = function (this__4384__auto__) {
  var self__ = this;
  var this__4384__auto____$1 = this;
  return 1 + cljs.core.count(self__.__extmap);
};

expound.paths.KeyPathSegment.prototype.cljs$core$IHash$_hash$arity$1 = function (this__4376__auto__) {
  var self__ = this;
  var this__4376__auto____$1 = this;
  var h__4238__auto__ = self__.__hash;

  if (!(h__4238__auto__ == null)) {
    return h__4238__auto__;
  } else {
    var h__4238__auto____$1 = function (coll__4377__auto__) {
      return 233526946 ^ cljs.core.hash_unordered_coll(coll__4377__auto__);
    }(this__4376__auto____$1);

    self__.__hash = h__4238__auto____$1;
    return h__4238__auto____$1;
  }
};

expound.paths.KeyPathSegment.prototype.cljs$core$IEquiv$_equiv$arity$2 = function (this27755, other27756) {
  var self__ = this;
  var this27755__$1 = this;
  return !(other27756 == null) && this27755__$1.constructor === other27756.constructor && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this27755__$1.key, other27756.key) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this27755__$1.__extmap, other27756.__extmap);
};

expound.paths.KeyPathSegment.prototype.cljs$core$IMap$_dissoc$arity$2 = function (this__4389__auto__, k__4390__auto__) {
  var self__ = this;
  var this__4389__auto____$1 = this;

  if (cljs.core.contains_QMARK_(new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "key", "key", -1516042587), null], null), null), k__4390__auto__)) {
    return cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(cljs.core._with_meta(cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, this__4389__auto____$1), self__.__meta), k__4390__auto__);
  } else {
    return new expound.paths.KeyPathSegment(self__.key, self__.__meta, cljs.core.not_empty(cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(self__.__extmap, k__4390__auto__)), null);
  }
};

expound.paths.KeyPathSegment.prototype.cljs$core$IAssociative$_assoc$arity$3 = function (this__4387__auto__, k__4388__auto__, G__27753) {
  var self__ = this;
  var this__4387__auto____$1 = this;
  var pred__27765 = cljs.core.keyword_identical_QMARK_;
  var expr__27766 = k__4388__auto__;

  if (cljs.core.truth_(pred__27765.cljs$core$IFn$_invoke$arity$2 ? pred__27765.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "key", "key", -1516042587), expr__27766) : pred__27765.call(null, new cljs.core.Keyword(null, "key", "key", -1516042587), expr__27766))) {
    return new expound.paths.KeyPathSegment(G__27753, self__.__meta, self__.__extmap, null);
  } else {
    return new expound.paths.KeyPathSegment(self__.key, self__.__meta, cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k__4388__auto__, G__27753), null);
  }
};

expound.paths.KeyPathSegment.prototype.cljs$core$ISeqable$_seq$arity$1 = function (this__4392__auto__) {
  var self__ = this;
  var this__4392__auto____$1 = this;
  return cljs.core.seq(cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.MapEntry(new cljs.core.Keyword(null, "key", "key", -1516042587), self__.key, null)], null), self__.__extmap));
};

expound.paths.KeyPathSegment.prototype.cljs$core$IWithMeta$_with_meta$arity$2 = function (this__4379__auto__, G__27753) {
  var self__ = this;
  var this__4379__auto____$1 = this;
  return new expound.paths.KeyPathSegment(self__.key, G__27753, self__.__extmap, self__.__hash);
};

expound.paths.KeyPathSegment.prototype.cljs$core$ICollection$_conj$arity$2 = function (this__4385__auto__, entry__4386__auto__) {
  var self__ = this;
  var this__4385__auto____$1 = this;

  if (cljs.core.vector_QMARK_(entry__4386__auto__)) {
    return this__4385__auto____$1.cljs$core$IAssociative$_assoc$arity$3(null, cljs.core._nth(entry__4386__auto__, 0), cljs.core._nth(entry__4386__auto__, 1));
  } else {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core._conj, this__4385__auto____$1, entry__4386__auto__);
  }
};

expound.paths.KeyPathSegment.getBasis = function () {
  return new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "key", "key", 124488940, null)], null);
};

expound.paths.KeyPathSegment.cljs$lang$type = true;

expound.paths.KeyPathSegment.cljs$lang$ctorPrSeq = function (this__4423__auto__) {
  return new cljs.core.List(null, "expound.paths/KeyPathSegment", null, 1, null);
};

expound.paths.KeyPathSegment.cljs$lang$ctorPrWriter = function (this__4423__auto__, writer__4424__auto__) {
  return cljs.core._write(writer__4424__auto__, "expound.paths/KeyPathSegment");
};
/**
 * Positional factory function for expound.paths/KeyPathSegment.
 */


expound.paths.__GT_KeyPathSegment = function expound$paths$__GT_KeyPathSegment(key) {
  return new expound.paths.KeyPathSegment(key, null, null, null);
};
/**
 * Factory function for expound.paths/KeyPathSegment, taking a map of keywords to field values.
 */


expound.paths.map__GT_KeyPathSegment = function expound$paths$map__GT_KeyPathSegment(G__27757) {
  var extmap__4419__auto__ = function () {
    var G__27768 = cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(G__27757, new cljs.core.Keyword(null, "key", "key", -1516042587));

    if (cljs.core.record_QMARK_(G__27757)) {
      return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, G__27768);
    } else {
      return G__27768;
    }
  }();

  return new expound.paths.KeyPathSegment(new cljs.core.Keyword(null, "key", "key", -1516042587).cljs$core$IFn$_invoke$arity$1(G__27757), null, cljs.core.not_empty(extmap__4419__auto__), null);
};
/**
* @constructor
 * @implements {cljs.core.IRecord}
 * @implements {cljs.core.IKVReduce}
 * @implements {cljs.core.IEquiv}
 * @implements {cljs.core.IHash}
 * @implements {cljs.core.ICollection}
 * @implements {cljs.core.ICounted}
 * @implements {cljs.core.ISeqable}
 * @implements {cljs.core.IMeta}
 * @implements {cljs.core.ICloneable}
 * @implements {cljs.core.IPrintWithWriter}
 * @implements {cljs.core.IIterable}
 * @implements {cljs.core.IWithMeta}
 * @implements {cljs.core.IAssociative}
 * @implements {cljs.core.IMap}
 * @implements {cljs.core.ILookup}
*/


expound.paths.KeyValuePathSegment = function (idx, __meta, __extmap, __hash) {
  this.idx = idx;
  this.__meta = __meta;
  this.__extmap = __extmap;
  this.__hash = __hash;
  this.cljs$lang$protocol_mask$partition0$ = 2230716170;
  this.cljs$lang$protocol_mask$partition1$ = 139264;
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$ILookup$_lookup$arity$2 = function (this__4380__auto__, k__4381__auto__) {
  var self__ = this;
  var this__4380__auto____$1 = this;
  return this__4380__auto____$1.cljs$core$ILookup$_lookup$arity$3(null, k__4381__auto__, null);
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$ILookup$_lookup$arity$3 = function (this__4382__auto__, k27770, else__4383__auto__) {
  var self__ = this;
  var this__4382__auto____$1 = this;
  var G__27774 = k27770;
  var G__27774__$1 = G__27774 instanceof cljs.core.Keyword ? G__27774.fqn : null;

  switch (G__27774__$1) {
    case "idx":
      return self__.idx;
      break;

    default:
      return cljs.core.get.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k27770, else__4383__auto__);
  }
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IKVReduce$_kv_reduce$arity$3 = function (this__4399__auto__, f__4400__auto__, init__4401__auto__) {
  var self__ = this;
  var this__4399__auto____$1 = this;
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ret__4402__auto__, p__27775) {
    var vec__27776 = p__27775;
    var k__4403__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27776, 0, null);
    var v__4404__auto__ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27776, 1, null);
    return f__4400__auto__.cljs$core$IFn$_invoke$arity$3 ? f__4400__auto__.cljs$core$IFn$_invoke$arity$3(ret__4402__auto__, k__4403__auto__, v__4404__auto__) : f__4400__auto__.call(null, ret__4402__auto__, k__4403__auto__, v__4404__auto__);
  }, init__4401__auto__, this__4399__auto____$1);
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IPrintWithWriter$_pr_writer$arity$3 = function (this__4394__auto__, writer__4395__auto__, opts__4396__auto__) {
  var self__ = this;
  var this__4394__auto____$1 = this;

  var pr_pair__4397__auto__ = function pr_pair__4397__auto__(keyval__4398__auto__) {
    return cljs.core.pr_sequential_writer(writer__4395__auto__, cljs.core.pr_writer, "", " ", "", opts__4396__auto__, keyval__4398__auto__);
  };

  return cljs.core.pr_sequential_writer(writer__4395__auto__, pr_pair__4397__auto__, "#expound.paths.KeyValuePathSegment{", ", ", "}", opts__4396__auto__, cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "idx", "idx", 1053688473), self__.idx], null)], null), self__.__extmap));
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IIterable$_iterator$arity$1 = function (G__27769) {
  var self__ = this;
  var G__27769__$1 = this;
  return new cljs.core.RecordIter(0, G__27769__$1, 1, new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Keyword(null, "idx", "idx", 1053688473)], null), cljs.core.truth_(self__.__extmap) ? cljs.core._iterator(self__.__extmap) : cljs.core.nil_iter());
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IMeta$_meta$arity$1 = function (this__4378__auto__) {
  var self__ = this;
  var this__4378__auto____$1 = this;
  return self__.__meta;
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$ICloneable$_clone$arity$1 = function (this__4375__auto__) {
  var self__ = this;
  var this__4375__auto____$1 = this;
  return new expound.paths.KeyValuePathSegment(self__.idx, self__.__meta, self__.__extmap, self__.__hash);
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$ICounted$_count$arity$1 = function (this__4384__auto__) {
  var self__ = this;
  var this__4384__auto____$1 = this;
  return 1 + cljs.core.count(self__.__extmap);
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IHash$_hash$arity$1 = function (this__4376__auto__) {
  var self__ = this;
  var this__4376__auto____$1 = this;
  var h__4238__auto__ = self__.__hash;

  if (!(h__4238__auto__ == null)) {
    return h__4238__auto__;
  } else {
    var h__4238__auto____$1 = function (coll__4377__auto__) {
      return 1269438429 ^ cljs.core.hash_unordered_coll(coll__4377__auto__);
    }(this__4376__auto____$1);

    self__.__hash = h__4238__auto____$1;
    return h__4238__auto____$1;
  }
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IEquiv$_equiv$arity$2 = function (this27771, other27772) {
  var self__ = this;
  var this27771__$1 = this;
  return !(other27772 == null) && this27771__$1.constructor === other27772.constructor && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this27771__$1.idx, other27772.idx) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(this27771__$1.__extmap, other27772.__extmap);
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IMap$_dissoc$arity$2 = function (this__4389__auto__, k__4390__auto__) {
  var self__ = this;
  var this__4389__auto____$1 = this;

  if (cljs.core.contains_QMARK_(new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 1, [new cljs.core.Keyword(null, "idx", "idx", 1053688473), null], null), null), k__4390__auto__)) {
    return cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(cljs.core._with_meta(cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, this__4389__auto____$1), self__.__meta), k__4390__auto__);
  } else {
    return new expound.paths.KeyValuePathSegment(self__.idx, self__.__meta, cljs.core.not_empty(cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(self__.__extmap, k__4390__auto__)), null);
  }
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IAssociative$_assoc$arity$3 = function (this__4387__auto__, k__4388__auto__, G__27769) {
  var self__ = this;
  var this__4387__auto____$1 = this;
  var pred__27781 = cljs.core.keyword_identical_QMARK_;
  var expr__27782 = k__4388__auto__;

  if (cljs.core.truth_(pred__27781.cljs$core$IFn$_invoke$arity$2 ? pred__27781.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword(null, "idx", "idx", 1053688473), expr__27782) : pred__27781.call(null, new cljs.core.Keyword(null, "idx", "idx", 1053688473), expr__27782))) {
    return new expound.paths.KeyValuePathSegment(G__27769, self__.__meta, self__.__extmap, null);
  } else {
    return new expound.paths.KeyValuePathSegment(self__.idx, self__.__meta, cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(self__.__extmap, k__4388__auto__, G__27769), null);
  }
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$ISeqable$_seq$arity$1 = function (this__4392__auto__) {
  var self__ = this;
  var this__4392__auto____$1 = this;
  return cljs.core.seq(cljs.core.concat.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.MapEntry(new cljs.core.Keyword(null, "idx", "idx", 1053688473), self__.idx, null)], null), self__.__extmap));
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$IWithMeta$_with_meta$arity$2 = function (this__4379__auto__, G__27769) {
  var self__ = this;
  var this__4379__auto____$1 = this;
  return new expound.paths.KeyValuePathSegment(self__.idx, G__27769, self__.__extmap, self__.__hash);
};

expound.paths.KeyValuePathSegment.prototype.cljs$core$ICollection$_conj$arity$2 = function (this__4385__auto__, entry__4386__auto__) {
  var self__ = this;
  var this__4385__auto____$1 = this;

  if (cljs.core.vector_QMARK_(entry__4386__auto__)) {
    return this__4385__auto____$1.cljs$core$IAssociative$_assoc$arity$3(null, cljs.core._nth(entry__4386__auto__, 0), cljs.core._nth(entry__4386__auto__, 1));
  } else {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core._conj, this__4385__auto____$1, entry__4386__auto__);
  }
};

expound.paths.KeyValuePathSegment.getBasis = function () {
  return new cljs.core.PersistentVector(null, 1, 5, cljs.core.PersistentVector.EMPTY_NODE, [new cljs.core.Symbol(null, "idx", "idx", -1600747296, null)], null);
};

expound.paths.KeyValuePathSegment.cljs$lang$type = true;

expound.paths.KeyValuePathSegment.cljs$lang$ctorPrSeq = function (this__4423__auto__) {
  return new cljs.core.List(null, "expound.paths/KeyValuePathSegment", null, 1, null);
};

expound.paths.KeyValuePathSegment.cljs$lang$ctorPrWriter = function (this__4423__auto__, writer__4424__auto__) {
  return cljs.core._write(writer__4424__auto__, "expound.paths/KeyValuePathSegment");
};
/**
 * Positional factory function for expound.paths/KeyValuePathSegment.
 */


expound.paths.__GT_KeyValuePathSegment = function expound$paths$__GT_KeyValuePathSegment(idx) {
  return new expound.paths.KeyValuePathSegment(idx, null, null, null);
};
/**
 * Factory function for expound.paths/KeyValuePathSegment, taking a map of keywords to field values.
 */


expound.paths.map__GT_KeyValuePathSegment = function expound$paths$map__GT_KeyValuePathSegment(G__27773) {
  var extmap__4419__auto__ = function () {
    var G__27784 = cljs.core.dissoc.cljs$core$IFn$_invoke$arity$2(G__27773, new cljs.core.Keyword(null, "idx", "idx", 1053688473));

    if (cljs.core.record_QMARK_(G__27773)) {
      return cljs.core.into.cljs$core$IFn$_invoke$arity$2(cljs.core.PersistentArrayMap.EMPTY, G__27784);
    } else {
      return G__27784;
    }
  }();

  return new expound.paths.KeyValuePathSegment(new cljs.core.Keyword(null, "idx", "idx", 1053688473).cljs$core$IFn$_invoke$arity$1(G__27773), null, cljs.core.not_empty(extmap__4419__auto__), null);
};

expound.paths.kps_QMARK_ = function expound$paths$kps_QMARK_(x) {
  return x instanceof expound.paths.KeyPathSegment;
};

expound.paths.kvps_QMARK_ = function expound$paths$kvps_QMARK_(x) {
  return x instanceof expound.paths.KeyValuePathSegment;
};

expound.paths.fn_equal = function expound$paths$fn_equal(x, y) {
  return cljs.core.fn_QMARK_(x) && cljs.core.fn_QMARK_(y) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(cljs.core.pr_str.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([x], 0)), cljs.core.pr_str.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([y], 0)));
};

expound.paths.both_nan_QMARK_ = function expound$paths$both_nan_QMARK_(x, y) {
  var and__4115__auto__ = expound.util.nan_QMARK_(x);

  if (cljs.core.truth_(and__4115__auto__)) {
    return expound.util.nan_QMARK_(y);
  } else {
    return and__4115__auto__;
  }
};

expound.paths.equalish_QMARK_ = function expound$paths$equalish_QMARK_(x, y) {
  var or__4126__auto__ = cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(x, y);

  if (or__4126__auto__) {
    return or__4126__auto__;
  } else {
    var or__4126__auto____$1 = expound.paths.fn_equal(x, y);

    if (or__4126__auto____$1) {
      return or__4126__auto____$1;
    } else {
      return expound.paths.both_nan_QMARK_(x, y);
    }
  }
};

expound.paths.in_with_kps_maps_as_seqs = function expound$paths$in_with_kps_maps_as_seqs(form, val, in$, in_SINGLEQUOTE_) {
  var vec__27788 = in$;
  var seq__27789 = cljs.core.seq(vec__27788);
  var first__27790 = cljs.core.first(seq__27789);
  var seq__27789__$1 = cljs.core.next(seq__27789);
  var k = first__27790;
  var rst = seq__27789__$1;
  var vec__27791 = rst;
  var seq__27792 = cljs.core.seq(vec__27791);
  var first__27793 = cljs.core.first(seq__27792);
  var seq__27792__$1 = cljs.core.next(seq__27792);
  var idx = first__27793;
  var rst2 = seq__27792__$1;

  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795), form)) {
    return new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795);
  } else {
    if (cljs.core.truth_(cljs.core.empty_QMARK_(in$) ? expound.paths.equalish_QMARK_(form, val) : false)) {
      return in_SINGLEQUOTE_;
    } else {
      if (cljs.core.map_QMARK_(form) && cljs.core.nat_int_QMARK_(k) && cljs.core.long$(k) < cljs.core.count(cljs.core.seq(form))) {
        var G__27794 = cljs.core.nth.cljs$core$IFn$_invoke$arity$2(cljs.core.seq(form), k);
        var G__27795 = val;
        var G__27796 = rst;
        var G__27797 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(in_SINGLEQUOTE_, expound.paths.__GT_KeyValuePathSegment(k));
        return expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4 ? expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4(G__27794, G__27795, G__27796, G__27797) : expound.paths.in_with_kps_STAR_.call(null, G__27794, G__27795, G__27796, G__27797);
      } else {
        if (cljs.core.map_QMARK_(form) && cljs.core.nat_int_QMARK_(k) && cljs.core.int_QMARK_(idx) && cljs.core.long$(k) < cljs.core.count(cljs.core.seq(form)) && cljs.core.long$(idx) < cljs.core.count(cljs.core.nth.cljs$core$IFn$_invoke$arity$2(cljs.core.seq(form), k))) {
          var G__27798 = cljs.core.nth.cljs$core$IFn$_invoke$arity$2(cljs.core.nth.cljs$core$IFn$_invoke$arity$2(cljs.core.seq(form), k), idx);
          var G__27799 = val;
          var G__27800 = rst2;
          var G__27801 = cljs.core.conj.cljs$core$IFn$_invoke$arity$variadic(in_SINGLEQUOTE_, expound.paths.__GT_KeyValuePathSegment(k), cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([idx], 0));
          return expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4 ? expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4(G__27798, G__27799, G__27800, G__27801) : expound.paths.in_with_kps_STAR_.call(null, G__27798, G__27799, G__27800, G__27801);
        } else {
          return new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795);
        }
      }
    }
  }
};

expound.paths.in_with_kps_fuzzy_match_for_regex_failures = function expound$paths$in_with_kps_fuzzy_match_for_regex_failures(form, val, in$, in_SINGLEQUOTE_) {
  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(form, new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795))) {
    return form;
  } else {
    var vec__27802 = in$;
    var seq__27803 = cljs.core.seq(vec__27802);
    var first__27804 = cljs.core.first(seq__27803);
    var seq__27803__$1 = cljs.core.next(seq__27803);
    var k = first__27804;
    var rst = seq__27803__$1;

    if (cljs.core.empty_QMARK_(in$) && cljs.core.seqable_QMARK_(form) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(val, cljs.core.List.EMPTY)) {
      return in_SINGLEQUOTE_;
    } else {
      if (cljs.core.empty_QMARK_(in$) && cljs.core.seq_QMARK_(val) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(form, cljs.core.first(val))) {
        return in_SINGLEQUOTE_;
      } else {
        if (cljs.core.nat_int_QMARK_(k) && cljs.core.seqable_QMARK_(form)) {
          var G__27805 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(cljs.core.seq(form), k, new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795));
          var G__27806 = val;
          var G__27807 = rst;
          var G__27808 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(in_SINGLEQUOTE_, k);
          return expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4 ? expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4(G__27805, G__27806, G__27807, G__27808) : expound.paths.in_with_kps_STAR_.call(null, G__27805, G__27806, G__27807, G__27808);
        } else {
          return new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795);
        }
      }
    }
  }
};

expound.paths.in_with_kps_ints_are_keys = function expound$paths$in_with_kps_ints_are_keys(form, val, in$, in_SINGLEQUOTE_) {
  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(form, new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795))) {
    return form;
  } else {
    var vec__27809 = in$;
    var seq__27810 = cljs.core.seq(vec__27809);
    var first__27811 = cljs.core.first(seq__27810);
    var seq__27810__$1 = cljs.core.next(seq__27810);
    var k = first__27811;
    var rst = seq__27810__$1;

    if (cljs.core.truth_(cljs.core.empty_QMARK_(in$) ? expound.paths.equalish_QMARK_(form, val) : false)) {
      return in_SINGLEQUOTE_;
    } else {
      if (cljs.core.associative_QMARK_(form)) {
        var G__27815 = cljs.core.get.cljs$core$IFn$_invoke$arity$3(form, k, new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795));
        var G__27816 = val;
        var G__27817 = rst;
        var G__27818 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(in_SINGLEQUOTE_, k);
        return expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4 ? expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4(G__27815, G__27816, G__27817, G__27818) : expound.paths.in_with_kps_STAR_.call(null, G__27815, G__27816, G__27817, G__27818);
      } else {
        if (cljs.core.int_QMARK_(k) && cljs.core.seqable_QMARK_(form)) {
          var G__27819 = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(cljs.core.seq(form), k, new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795));
          var G__27820 = val;
          var G__27821 = rst;
          var G__27822 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(in_SINGLEQUOTE_, k);
          return expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4 ? expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4(G__27819, G__27820, G__27821, G__27822) : expound.paths.in_with_kps_STAR_.call(null, G__27819, G__27820, G__27821, G__27822);
        } else {
          return new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795);
        }
      }
    }
  }
};

expound.paths.in_with_kps_ints_are_key_value_indicators = function expound$paths$in_with_kps_ints_are_key_value_indicators(form, val, in$, in_SINGLEQUOTE_) {
  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(form, new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795))) {
    return form;
  } else {
    var vec__27823 = in$;
    var seq__27824 = cljs.core.seq(vec__27823);
    var first__27825 = cljs.core.first(seq__27824);
    var seq__27824__$1 = cljs.core.next(seq__27824);
    var k = first__27825;
    var rst = seq__27824__$1;
    var vec__27826 = rst;
    var seq__27827 = cljs.core.seq(vec__27826);
    var first__27828 = cljs.core.first(seq__27827);
    var seq__27827__$1 = cljs.core.next(seq__27827);
    var idx = first__27828;
    var rst2 = seq__27827__$1;

    if (cljs.core.truth_(cljs.core.empty_QMARK_(in$) ? expound.paths.equalish_QMARK_(form, val) : false)) {
      return in_SINGLEQUOTE_;
    } else {
      if (cljs.core.map_QMARK_(form) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(0, idx)) {
        var G__27829 = k;
        var G__27830 = val;
        var G__27831 = rst2;
        var G__27832 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(in_SINGLEQUOTE_, expound.paths.__GT_KeyPathSegment(k));
        return expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4 ? expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4(G__27829, G__27830, G__27831, G__27832) : expound.paths.in_with_kps_STAR_.call(null, G__27829, G__27830, G__27831, G__27832);
      } else {
        if (cljs.core.map_QMARK_(form) && cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(1, idx)) {
          var G__27833 = cljs.core.get.cljs$core$IFn$_invoke$arity$3(form, k, new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795));
          var G__27834 = val;
          var G__27835 = rst2;
          var G__27836 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(in_SINGLEQUOTE_, k);
          return expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4 ? expound.paths.in_with_kps_STAR_.cljs$core$IFn$_invoke$arity$4(G__27833, G__27834, G__27835, G__27836) : expound.paths.in_with_kps_STAR_.call(null, G__27833, G__27834, G__27835, G__27836);
        } else {
          return new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795);
        }
      }
    }
  }
};

expound.paths.in_with_kps_STAR_ = function expound$paths$in_with_kps_STAR_(form, val, in$, in_SINGLEQUOTE_) {
  if (cljs.core.fn_QMARK_(form)) {
    return in_SINGLEQUOTE_;
  } else {
    var br1 = expound.paths.in_with_kps_ints_are_key_value_indicators(form, val, in$, in_SINGLEQUOTE_);

    if (cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795), br1)) {
      return br1;
    } else {
      var br2 = expound.paths.in_with_kps_maps_as_seqs(form, val, in$, in_SINGLEQUOTE_);

      if (cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795), br2)) {
        return br2;
      } else {
        var br3 = expound.paths.in_with_kps_ints_are_keys(form, val, in$, in_SINGLEQUOTE_);

        if (cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795), br3)) {
          return br3;
        } else {
          var br4 = expound.paths.in_with_kps_fuzzy_match_for_regex_failures(form, val, in$, in_SINGLEQUOTE_);

          if (cljs.core.not_EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795), br4)) {
            return br4;
          } else {
            return new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795);
          }
        }
      }
    }
  }
};

expound.paths.paths_to_value = function expound$paths$paths_to_value(form, val, path, paths) {
  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(form, val)) {
    return cljs.core.conj.cljs$core$IFn$_invoke$arity$2(paths, path);
  } else {
    if (cljs.core.sequential_QMARK_(form) || cljs.core.set_QMARK_(form)) {
      return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ps, p__27837) {
        var vec__27838 = p__27837;
        var x = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27838, 0, null);
        var i = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27838, 1, null);
        var G__27841 = x;
        var G__27842 = val;
        var G__27843 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(path, i);
        var G__27844 = ps;
        return expound.paths.paths_to_value.cljs$core$IFn$_invoke$arity$4 ? expound.paths.paths_to_value.cljs$core$IFn$_invoke$arity$4(G__27841, G__27842, G__27843, G__27844) : expound.paths.paths_to_value.call(null, G__27841, G__27842, G__27843, G__27844);
      }, paths, cljs.core.map.cljs$core$IFn$_invoke$arity$3(cljs.core.vector, form, cljs.core.range.cljs$core$IFn$_invoke$arity$0()));
    } else {
      if (cljs.core.map_QMARK_(form)) {
        return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ps, p__27845) {
          var vec__27846 = p__27845;
          var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27846, 0, null);
          var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__27846, 1, null);
          var G__27849 = v;
          var G__27850 = val;
          var G__27851 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(path, k);

          var G__27852 = function () {
            var G__27853 = k;
            var G__27854 = val;
            var G__27855 = cljs.core.conj.cljs$core$IFn$_invoke$arity$2(path, expound.paths.__GT_KeyPathSegment(k));
            var G__27856 = ps;
            return expound.paths.paths_to_value.cljs$core$IFn$_invoke$arity$4 ? expound.paths.paths_to_value.cljs$core$IFn$_invoke$arity$4(G__27853, G__27854, G__27855, G__27856) : expound.paths.paths_to_value.call(null, G__27853, G__27854, G__27855, G__27856);
          }();

          return expound.paths.paths_to_value.cljs$core$IFn$_invoke$arity$4 ? expound.paths.paths_to_value.cljs$core$IFn$_invoke$arity$4(G__27849, G__27850, G__27851, G__27852) : expound.paths.paths_to_value.call(null, G__27849, G__27850, G__27851, G__27852);
        }, paths, form);
      } else {
        return paths;
      }
    }
  }
};

expound.paths.in_with_kps = function expound$paths$in_with_kps(form, val, in$, in_SINGLEQUOTE_) {
  var res = expound.paths.in_with_kps_STAR_(form, val, in$, in_SINGLEQUOTE_);

  if (cljs.core._EQ_.cljs$core$IFn$_invoke$arity$2(new cljs.core.Keyword("expound.paths", "not-found", "expound.paths/not-found", -195785795), res)) {
    return null;
  } else {
    return res;
  }
};

expound.paths.compare_path_segment = function expound$paths$compare_path_segment(x, y) {
  if (cljs.core.int_QMARK_(x) && expound.paths.kvps_QMARK_(y)) {
    return cljs.core.compare(x, new cljs.core.Keyword(null, "idx", "idx", 1053688473).cljs$core$IFn$_invoke$arity$1(y));
  } else {
    if (expound.paths.kvps_QMARK_(x) && cljs.core.int_QMARK_(y)) {
      return cljs.core.compare(new cljs.core.Keyword(null, "idx", "idx", 1053688473).cljs$core$IFn$_invoke$arity$1(x), y);
    } else {
      if (expound.paths.kps_QMARK_(x) && !expound.paths.kps_QMARK_(y)) {
        return -1;
      } else {
        if (!expound.paths.kps_QMARK_(x) && expound.paths.kps_QMARK_(y)) {
          return 1;
        } else {
          if (cljs.core.vector_QMARK_(x) && cljs.core.vector_QMARK_(y)) {
            return expound.paths.compare_paths.cljs$core$IFn$_invoke$arity$2 ? expound.paths.compare_paths.cljs$core$IFn$_invoke$arity$2(x, y) : expound.paths.compare_paths.call(null, x, y);
          } else {
            return cljs.core.compare(x, y);
          }
        }
      }
    }
  }
};

expound.paths.compare_paths = function expound$paths$compare_paths(path1, path2) {
  return cljs.core.first(cljs.core.remove.cljs$core$IFn$_invoke$arity$2(new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 1, [0, null], null), null), cljs.core.map.cljs$core$IFn$_invoke$arity$3(expound.paths.compare_path_segment, path1, path2)));
};
/**
 * Similar to get-in, but works with paths that reference map keys
 */


expound.paths.value_in = function expound$paths$value_in(form, in$) {
  while (true) {
    if (in$ == null) {
      return form;
    } else {
      var vec__27861 = in$;
      var seq__27862 = cljs.core.seq(vec__27861);
      var first__27863 = cljs.core.first(seq__27862);
      var seq__27862__$1 = cljs.core.next(seq__27862);
      var k = first__27863;
      var rst = seq__27862__$1;

      if (cljs.core.empty_QMARK_(in$)) {
        return form;
      } else {
        if (cljs.core.map_QMARK_(form) && expound.paths.kps_QMARK_(k)) {
          var G__27898 = new cljs.core.Keyword(null, "key", "key", -1516042587).cljs$core$IFn$_invoke$arity$1(k);
          var G__27899 = rst;
          form = G__27898;
          in$ = G__27899;
          continue;
        } else {
          if (cljs.core.map_QMARK_(form) && expound.paths.kvps_QMARK_(k)) {
            var G__27900 = cljs.core.nth.cljs$core$IFn$_invoke$arity$2(cljs.core.seq(form), new cljs.core.Keyword(null, "idx", "idx", 1053688473).cljs$core$IFn$_invoke$arity$1(k));
            var G__27901 = rst;
            form = G__27900;
            in$ = G__27901;
            continue;
          } else {
            if (cljs.core.associative_QMARK_(form)) {
              var G__27902 = cljs.core.get.cljs$core$IFn$_invoke$arity$2(form, k);
              var G__27903 = rst;
              form = G__27902;
              in$ = G__27903;
              continue;
            } else {
              if (cljs.core.int_QMARK_(k) && cljs.core.seqable_QMARK_(form)) {
                var G__27904 = cljs.core.nth.cljs$core$IFn$_invoke$arity$2(cljs.core.seq(form), k);
                var G__27905 = rst;
                form = G__27904;
                in$ = G__27905;
                continue;
              } else {
                throw cljs.core.ex_info.cljs$core$IFn$_invoke$arity$2("No value found", new cljs.core.PersistentArrayMap(null, 2, [new cljs.core.Keyword(null, "form", "form", -1624062471), form, new cljs.core.Keyword(null, "in", "in", -1531184865), in$], null));
              }
            }
          }
        }
      }
    }

    break;
  }
};

Object.defineProperty(module.exports, "map__GT_KeyPathSegment", {
  enumerable: false,
  get: function get() {
    return expound.paths.map__GT_KeyPathSegment;
  }
});
Object.defineProperty(module.exports, "paths_to_value", {
  enumerable: false,
  get: function get() {
    return expound.paths.paths_to_value;
  }
});
Object.defineProperty(module.exports, "equalish_QMARK_", {
  enumerable: false,
  get: function get() {
    return expound.paths.equalish_QMARK_;
  }
});
Object.defineProperty(module.exports, "in_with_kps", {
  enumerable: false,
  get: function get() {
    return expound.paths.in_with_kps;
  }
});
Object.defineProperty(module.exports, "KeyPathSegment", {
  enumerable: false,
  get: function get() {
    return expound.paths.KeyPathSegment;
  }
});
Object.defineProperty(module.exports, "__GT_KeyValuePathSegment", {
  enumerable: false,
  get: function get() {
    return expound.paths.__GT_KeyValuePathSegment;
  }
});
Object.defineProperty(module.exports, "value_in", {
  enumerable: false,
  get: function get() {
    return expound.paths.value_in;
  }
});
Object.defineProperty(module.exports, "kvps_QMARK_", {
  enumerable: false,
  get: function get() {
    return expound.paths.kvps_QMARK_;
  }
});
Object.defineProperty(module.exports, "__GT_KeyPathSegment", {
  enumerable: false,
  get: function get() {
    return expound.paths.__GT_KeyPathSegment;
  }
});
Object.defineProperty(module.exports, "in_with_kps_ints_are_keys", {
  enumerable: false,
  get: function get() {
    return expound.paths.in_with_kps_ints_are_keys;
  }
});
Object.defineProperty(module.exports, "compare_path_segment", {
  enumerable: false,
  get: function get() {
    return expound.paths.compare_path_segment;
  }
});
Object.defineProperty(module.exports, "KeyValuePathSegment", {
  enumerable: false,
  get: function get() {
    return expound.paths.KeyValuePathSegment;
  }
});
Object.defineProperty(module.exports, "compare_paths", {
  enumerable: false,
  get: function get() {
    return expound.paths.compare_paths;
  }
});
Object.defineProperty(module.exports, "in_with_kps_fuzzy_match_for_regex_failures", {
  enumerable: false,
  get: function get() {
    return expound.paths.in_with_kps_fuzzy_match_for_regex_failures;
  }
});
Object.defineProperty(module.exports, "map__GT_KeyValuePathSegment", {
  enumerable: false,
  get: function get() {
    return expound.paths.map__GT_KeyValuePathSegment;
  }
});
Object.defineProperty(module.exports, "in_with_kps_STAR_", {
  enumerable: false,
  get: function get() {
    return expound.paths.in_with_kps_STAR_;
  }
});
Object.defineProperty(module.exports, "in_with_kps_maps_as_seqs", {
  enumerable: false,
  get: function get() {
    return expound.paths.in_with_kps_maps_as_seqs;
  }
});
Object.defineProperty(module.exports, "in_with_kps_ints_are_key_value_indicators", {
  enumerable: false,
  get: function get() {
    return expound.paths.in_with_kps_ints_are_key_value_indicators;
  }
});
Object.defineProperty(module.exports, "fn_equal", {
  enumerable: false,
  get: function get() {
    return expound.paths.fn_equal;
  }
});
Object.defineProperty(module.exports, "kps_QMARK_", {
  enumerable: false,
  get: function get() {
    return expound.paths.kps_QMARK_;
  }
});
Object.defineProperty(module.exports, "both_nan_QMARK_", {
  enumerable: false,
  get: function get() {
    return expound.paths.both_nan_QMARK_;
  }
});